import { makeStyles } from '@material-ui/core/styles';
import { getStyle, mergeStyles } from './stylesSelector';
import { cloneDeep } from 'lodash';
import { CONTENT_MAX_WIDTH, styleBreakMobile } from '../components/utilities/layouts/Globals';
import { getCustomColors } from './CustomColors';

const Colors = getCustomColors();

export const LoginStyle = makeStyles(theme => {
    /* Default Styles */
    const defaultstyles = {
        container: {
            display: 'flex',
            justifyContent: 'space-between',
            height: '100%',

            [styleBreakMobile(theme)]: {
                justifyContent: 'center',
            },
        },
        logo: {
            marginBottom: theme.spacing(5),
            marginTop: '-50px',
            display: 'flex',
            width: '100%',

            [styleBreakMobile(theme)]: {
                marginBottom: theme.spacing(6),
                marginTop: theme.spacing(2),
                justifyContent: 'center',

                '& svg': {
                    width: 320,
                    height: 80,
                },
            },
        },
        loginImageLeft: {
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            [styleBreakMobile(theme)]: {
                display: 'none',
            },
        },
        nonFillFormWidth: {
            width: '50%',
            maxWidth: CONTENT_MAX_WIDTH,
            height: '100%',
            justifyContent: 'center',
            alignItems: 'center',

            '& form': {
                width: '100%',
            },

            [styleBreakMobile(theme)]: {
                width: '100%',
                maxWidth: 377,

                '& form': {
                    height: '55%',
                },
                '& form > div': {
                    height: '100%',
                },
            },
        },
        invisibleFlexItemForCenter: {
            [styleBreakMobile(theme)]: {
                height: 0,
                marginTop: 'auto',
            },
        },
    };

    // overrides to the default
    /* Add watchman specific styles */
    const watchmanstyles = mergeStyles(cloneDeep(defaultstyles), {
        loginField: {
            '& svg': {
                color: Colors.COLOR_GREY.main,
            },

            '& button svg': {
                stroke: Colors.COLOR_GREY.main,
                '& #surround': {
                    fill: Colors.COLOR_GREY.main,
                },
            },

            '& input::placeholder': {
                opacity: 1,
                color: Colors.COLOR_GREY.main,
            },

            '& input:placeholder-shown': {
                color: Colors.COLOR_GREY.main,
            },

            '& input:not(:placeholder-shown) ~ fieldset': {
                border: `1px solid ${theme.palette.primary.dark}`,
            },
        },

        // apply colour to icon if the field is filled
        textFilled: {
            '& svg': {
                color: theme.palette.primary.dark,
            },
            '& button svg': {
                stroke: theme.palette.primary.dark,
                '& #surround': {
                    fill: theme.palette.primary.dark,
                },
            },
        },
    });

    /* Add ned specific styles */
    // overrides to the default
    const nedstyles = mergeStyles(cloneDeep(defaultstyles), {
        logo: {
            marginBottom: theme.spacing(10),
            display: 'flex',
            justifyContent: 'center',
        },
    });

    return getStyle({
        ned: nedstyles,
        watchman: watchmanstyles,
    });
});
